import { render, staticRenderFns } from "./BtnCorrigirIndicacao.vue?vue&type=template&id=57adf3ec&"
import script from "./BtnCorrigirIndicacao.vue?vue&type=script&lang=js&"
export * from "./BtnCorrigirIndicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports